import React from 'react';
import styled from 'styled-components';

export const CloseTapTarget = styled(({ ...rest }) => <button tabIndex="0" {...rest} />)`
           border-radius: 100%;
           color: ${(props) => props?.color ?? props.theme.colors.monochrome.MC2};
           display: flex;
           align-items: center;
           justify-content: center;
           height: 2rem;
           width: 2rem;
           border: none;
           background: transparent;
           :hover {
               background-color: ${(props) => props.theme.colors.background.tintAlt};
               color: ${(props) => props.theme.colors.text.muted};
               cursor: pointer;
           }
           :active {
               background-color: ${(props) => props.theme.colors.brand.P5};
               color: ${(props) => props.theme.colors.fixed.white};
           }
       `;
